import { debounce } from "../utils/debounce.js";
import { initBurger } from "./header/burger.js";
import { initDropdown } from "./header/dropdown.js";
import { initMore } from "./header/more.js";

export const header = () => {
    initBurger();
    initDropdown();
    initMore();

};

header();
